import { cm } from '~/utils'

export type InitialsAvatarSize = 'xs' | 'sm' | 'md' | 'lg'

const sizeClasses: Record<InitialsAvatarSize, string> = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-base'
}

function getInitials(name: string): string {
  if (!name.trim()) return '?'
  return name
    .trim()
    .split(/\s+/)
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export interface InitialsAvatarProps {
  /** Display name for generating initials */
  name: string
  size?: InitialsAvatarSize
  className?: string
}

/**
 * Avatar with initials. Purple circle with white text.
 * Consolidated avatar used across the app (chat, sidebar, popover, etc).
 */
export function InitialsAvatar({ name, size = 'sm', className }: InitialsAvatarProps) {
  return (
    <div
      className={cm(
        sizeClasses[size],
        'bg-tokens-primary-2 rounded-full flex items-center justify-center shrink-0',
        className
      )}
    >
      <span className='text-white font-medium select-none'>{getInitials(name)}</span>
    </div>
  )
}
